



































import { Vue, Component, Prop } from "vue-property-decorator";
import ProductViewModel from "@/chipply/view-model/ProductViewModel";

@Component({})
export default class BasicProductInfo extends Vue {
    @Prop({ type: Object })
    public productViewModel!: ProductViewModel;

    @Prop({ type: Boolean })
    public showMakeASelectionHeader!: boolean;
}
